import React from 'react'

import { Text } from '@app/lib/typography/Text/Text'

export type TooltipMessageProps = {
  heading: string
  text: string
}

export const TooltipMessage = ({ heading, text }: TooltipMessageProps) => {
  return (
    <div>
      <Text size={'sm'} weight={'bold'} color={'white'}>
        {heading}
      </Text>
      <Text size={'sm'} color={'white'}>
        {text}
      </Text>
    </div>
  )
}
